/* eslint-disable consistent-return */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
import { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { toast } from 'react-toastify';
import { Autocomplete } from '@material-ui/lab';
import { Checkbox, FormControlLabel, Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import P from 'prop-types';
import { MaskedTextField } from '../FormFields';
import useApp from '../../hooks/useApp';
import { createUser, editUser } from '../../service/user.service';
import { sendMailVerify } from '../../service/mail.service';
import { compareAsc, parse } from 'date-fns';
import useSWR from 'swr';
import { fetcher, variantFetcher } from '../../service/SWRFetcher';
import { useAuth } from '../../hooks/useAuth';
import ReactInputMask from 'react-input-mask';

const UserForm = ({ open, setOpen, title, user, mutate, create = false }) => {
  const { user: loggedUser } = useAuth();

  const { channels, partners, technical_teams } = useApp();

  const { data: roles } = useSWR(`/roles?active=1`, fetcher, {
    revalidateOnFocus: false,
  });

  const [form, setForm] = useState({
    name: '',
    email: '',
    login: '',
    phone: '',
    observation: '',
    role: null,
    channel: null,
    partners: null,
    technical_team: null,
    status: true,
    active_all_dealerships: false,
    renovator_hierarchical_group: null,
  });

  const [invalidWorkStart, setInvalidWorkStarted] = useState(false);

  const entering = () => {
    setForm({
      name: user?.name,
      email: user?.email,
      phone: user?.phone,
      observation: user?.observation,
      role: user?.roles[0],
      channel: user?.channel,
      partners: user?.partners,
      technical_team: user?.technical_team,
      status: Boolean(user?.status),
      active_all_dealerships: Boolean(user?.active_all_dealerships),
      renovator_hierarchical_group: user?.renovator_hierarchical_group,
      work_start: user?.work_start,
    });
  };

  const clearForm = () => {
    setForm({
      name: '',
      email: '',
      login: '',
      phone: '',
      observation: '',
      role: null,
      channel: null,
      partners: null,
      technical_team: null,
      status: true,
      active_all_dealerships: false,
      renovator_hierarchical_group: null,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const submit = async (e) => {
    e?.preventDefault();

    const data = {
      name: form.name,
      email: form.email,
      login: form?.login,
      phone: form.phone,
      role: form.role.id,
      channel_id: form.role.id > 3 ? form.channel.id : 1,
      partners: form.partners,
      technical_team_id: form.technical_team?.id || null,
      observation: form?.observation,
      status: form.status,
      active_all_dealerships: form.active_all_dealerships,
      renovator_hierarchical_group: form.renovator_hierarchical_group,
      work_start: form.work_start,
    };

    if (invalidWorkStart) return toast.error('Horário de inicio de jornada inválido');

    try {
      if (create) await createUser(data);
      else await editUser(data, user.id);

      toast.success(`Usuário ${create ? 'criado' : 'atualizado'} com sucesso`);
      mutate();
      handleClose();
    } catch (error) {
      if (!error?.response?.data?.data) return toast.error(`Erro ao ${create ? 'criar' : 'modificar'} usuário`);

      Object.entries(error?.response?.data?.data).map(([field, messages]) => toast.error(messages[0]));
    }
  };

  const handleActive = async () => {
    try {
      const mailData = {
        id: user.id,
        name: form.name,
        verify_code: user.verify.verify_code,
        email: form.email,
      };
      sendMailVerify(mailData);
      submit();
    } catch {
      toast.error('Erro ao enviar e-mail para usuário');
    }
  };

  const handleChangeAutoComplete = (event, newValue, variable) => {
    if (!newValue) return;
    setForm({
      ...form,
      [variable]: newValue,
    });
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const handleChangeWorkStart = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    // 5 representa o tamanho válido do horario contando com o ponto
    if (value.length == 5) {
      const time = parse(value, 'HH:mm', new Date());
      const minimunTimeStart = parse('08:29', 'HH:mm', new Date());
      const maxTimeStart = parse('12:05', 'HH:mm', new Date());

      if (compareAsc(time, minimunTimeStart) == 1 && compareAsc(time, maxTimeStart) == -1) {
        setInvalidWorkStarted(false);
      } else {
        setInvalidWorkStarted(true);
      }
    }

    return setForm({
      ...form,
      work_start: value,
    });
  };

  useEffect(() => {
    if (!user) return clearForm();
    entering();
  }, [user]);

  return (
    <div>
      <Dialog TransitionProps={entering} open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle style={{ backgroundColor: '#fc986a' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            {title}
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <form onSubmit={submit}>
          <DialogContent>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Nome"
                  type="name"
                  value={form.name}
                  fullWidth
                  required
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  margin="dense"
                  label="E-mail"
                  type="email"
                  value={form.email}
                  fullWidth
                  required
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </Grid>
            </Grid>

            {create && (
              <TextField
                margin="dense"
                label="Login"
                value={form.login}
                fullWidth
                required
                onChange={(e) => setForm({ ...form, login: e.target.value })}
              />
            )}

            <ReactInputMask
              mask={form.phone?.replace(/[^\d]/g, '').length <= 10 ? '(99) 9999-9999?' : '(99) 99999-9999'}
              formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
              maskChar=""
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
              fullWidth>
              {(params) => <TextField variant="standard" margin="normal" label="Telefone" {...params} />}
            </ReactInputMask>

            <Grid container spacing={4}>
              <Grid item xs={12} md={form.role?.id ? 6 : 12}>
                <Autocomplete
                  options={roles}
                  value={form.role}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, newValue) => {
                    handleChangeAutoComplete(event, newValue, 'role');
                  }}
                  renderInput={(params) => <TextField {...params} variant="standard" label="Função" required />}
                />
              </Grid>

              {form.role?.id > 3 && (
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={channels}
                    value={form.channel}
                    getOptionSelected={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, newValue) => {
                      handleChangeAutoComplete(event, newValue, 'channel');
                    }}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" margin="dense" label="Canal" required />
                    )}
                  />
                </Grid>
              )}

              {form.role?.id <= 3 && (
                <>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      options={technical_teams}
                      value={form.technical_team}
                      getOptionSelected={(option, value) => option.id === value.id}
                      getOptionLabel={(option) => option.description}
                      onChange={(event, newValue) => {
                        handleChangeAutoComplete(event, newValue, 'technical_team');
                      }}
                      renderInput={(params) => <TextField {...params} variant="standard" label="Equipe técnica" />}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MaskedTextField
                      mask="999999999999999"
                      variant="standard"
                      value={form.renovator_hierarchical_group}
                      onChange={handleChange}
                      varibleName="renovator_hierarchical_group"
                      label="Grupo Hierárquico Renovador"
                      fullWidth
                    />
                  </Grid>
                </>
              )}
            </Grid>

            <MaskedTextField
              mask="99:99"
              variant="standard"
              value={form?.work_start}
              onChange={handleChangeWorkStart}
              varibleName="work_start"
              label="Início da jornada de trabalho"
              error={invalidWorkStart}
              helperText="O horário deve estar entre 08:30 e 12:00"
              fullWidth
            />

            <div style={{ margin: '10px 0 ' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.status}
                    onChange={(e) => setForm({ ...form, status: e.target.checked })}
                    color="default"
                  />
                }
                label="Usuário ativo"
              />
            </div>

            <div style={{ margin: '10px 0 30px 0', display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <h4>Observação</h4>

              <TextField
                value={form?.observation}
                onChange={(e) => setForm({ ...form, observation: e.target.value })}
                name="observation"
                label="Observação"
                fullWidth
                multiline
                maxRows={2}
              />
            </div>

            <div style={{ margin: '10px 0 30px 0', display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <h4>Empresas</h4>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.active_all_dealerships}
                    onChange={(e) => setForm({ ...form, active_all_dealerships: e.target.checked })}
                    color="default"
                  />
                }
                label="Ativar todas empresas"
              />

              {!form.active_all_dealerships && (
                <Autocomplete
                  multiple
                  options={partners}
                  value={form.partners || []}
                  getOptionSelected={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, newValue) => {
                    handleChangeAutoComplete(event, newValue, 'partners');
                  }}
                  renderInput={(params) => <TextField {...params} variant="standard" label="Empresas" />}
                />
              )}
            </div>
          </DialogContent>
          <DialogActions style={{ position: 'sticky', bottom: 0, backgroundColor: 'white', width: '100%' }}>
            {user?.verify && !user?.verify.verified ? (
              <Button color="primary" onClick={handleActive}>
                Enviar e-mail de confirmação
              </Button>
            ) : (
              ''
            )}
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button type="submit" color="primary">
              Salvar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default UserForm;
